import React, { useEffect, useState } from "react";
import PrimaryButton from "../buttons/PrimaryButton";

const EmptyDisplay1 = ({
  title = "Créez votre premier dossier",
  subtitle = "Les dossiers sont le centre de votre activité sur hexagone !",
  goAction,
  actionText = "",
  children,
  className = "",
}) => {
  const urls = [
    "https://products.ls.graphics/mesh-gradients/images/85.-Lily-White_1.jpg",
  ];
  const [url, setUrl] = useState(urls[Math.floor(Math.random() * urls.length)]);

  return (
    <div className="  h-full w-full  flex flex-row justify-start items-start">
      <div
        className={`relative justify-center items-center flex  w-fit h- ml-4 mt-4 mb-4  p-0 bg-white  border-1 rounded-xl ${
          className === ""
            ? "bg-gradient-to-br from-blue-200 via-30% via-transparent border border-blue-300  to-blue-200   rounded-lg"
            : className
        }`}
      >
        {/* Your content */}

        <div className="relative bg-gradient-to-r from-wshadow_75 to-transparent rounded-xl   ">
          <div className="relative  rounded-xl z-10 mr-48  flex flex-col gap-4 p-6 w-c300 ">
            <div className="text-h2 font-bold text-gray-800">{title}</div>{" "}
            <div className="text-h3 text-shadow_50">{subtitle}</div>
            {children
              ? children
              : goAction && (
                  <PrimaryButton onClick={goAction} className={"w-fit"}>
                    <div className="flex flex-row content-center items-center ">
                      {actionText}
                    </div>
                  </PrimaryButton>
                )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmptyDisplay1;
